import { _ as _define_property } from "@swc/helpers/_/_define_property";
import Decimal from 'decimal.js';
import { fromDateStampObject, toDateStampObject } from './time';
export var PriceIncreaseType = /*#__PURE__*/ function(PriceIncreaseType) {
    PriceIncreaseType["None"] = "none";
    PriceIncreaseType["Automatic"] = "automatic";
    return PriceIncreaseType;
}({});
export var IncreaseMethodType = /*#__PURE__*/ function(IncreaseMethodType) {
    IncreaseMethodType["Percent"] = "percent";
    return IncreaseMethodType;
}({});
export var RoundPrices = /*#__PURE__*/ function(RoundPrices) {
    RoundPrices["None"] = "none";
    RoundPrices["Down1"] = "down1";
    RoundPrices["Down5"] = "down5";
    RoundPrices["Down10"] = "down10";
    return RoundPrices;
}({});
export var IncreaseOnType = /*#__PURE__*/ function(IncreaseOnType) {
    IncreaseOnType["Yearly"] = "yearly";
    IncreaseOnType["EffectiveDate"] = "yearlyEffectiveDate";
    return IncreaseOnType;
}({});
export class PriceIncreaseModel {
    static fromDTO(dto) {
        switch(dto.type){
            case "none":
                return PriceIncreaseModel.makeNone();
            case "automatic":
                {
                    var _dto_automatic_startIncreaseOn;
                    const increaseOn = (_dto_automatic_startIncreaseOn = dto.automatic.startIncreaseOn) !== null && _dto_automatic_startIncreaseOn !== void 0 ? _dto_automatic_startIncreaseOn : dto.automatic.increaseOn;
                    return PriceIncreaseModel.make(dto.automatic.roundPrices, new Decimal(dto.automatic.increaseMethod.percent), increaseOn.periodType === "yearly" ? fromDateStampObject(increaseOn.yearly) : null);
                }
        }
    }
    static make(roundPrices, percentIncrease, increaseOn) {
        return new PriceIncreaseModel({
            roundPrices,
            percentIncrease,
            increaseOn
        });
    }
    static makeNone() {
        return new PriceIncreaseModel(null);
    }
    toDTO() {
        if (!this.data) {
            return {
                type: "none"
            };
        }
        const increaseOn = this.data.increaseOn ? {
            periodType: "yearly",
            yearly: toDateStampObject(this.data.increaseOn)
        } : {
            periodType: "yearlyEffectiveDate"
        };
        return {
            type: "automatic",
            automatic: {
                roundPrices: this.data.roundPrices,
                increaseMethod: {
                    type: "percent",
                    percent: this.data.percentIncrease.toString()
                },
                increaseOn,
                startIncreaseOn: increaseOn
            }
        };
    }
    toDB() {
        if (!this.data) {
            return {
                type: "none"
            };
        }
        const increaseOn = this.data.increaseOn ? {
            periodType: "yearly",
            yearly: toDateStampObject(this.data.increaseOn)
        } : {
            periodType: "yearlyEffectiveDate"
        };
        return {
            type: "automatic",
            automatic: {
                roundPrices: this.data.roundPrices,
                increaseMethod: {
                    type: "percent",
                    percent: this.data.percentIncrease.mul(100).toDP(0).toNumber()
                },
                increaseOn,
                startIncreaseOn: increaseOn
            }
        };
    }
    exists() {
        return !!this.data;
    }
    isNonPositiveIncrease() {
        return !this.data || this.data.percentIncrease.isZero() || this.data.percentIncrease.isNegative();
    }
    percentIncrease() {
        return this.data ? this.data.percentIncrease : new Decimal(0);
    }
    roundPrices() {
        return this.data ? this.data.roundPrices : "none";
    }
    increaseOn() {
        return this.data ? this.data.increaseOn : null;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
